import { useState, useEffect } from 'react';
import { getAdminStats } from '../../api/admin';
import s from './AdminPages.module.css';

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    getAdminStats()
      .then(setStats)
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <p className={s.loadingText}>Loading stats...</p>;
  if (error) return <p className={s.errorText}>Error: {error}</p>;

  const cards = [
    { label: 'Total Users', value: stats.total_users, color: '#6366f1' },
    { label: 'Active Subscriptions', value: stats.active_subscriptions, color: '#10b981' },
    { label: 'Trial Users', value: stats.trial_users, color: '#f59e0b' },
    { label: 'Stories Today', value: stats.stories_today, color: '#ec4899' },
    { label: 'Stories All Time', value: stats.stories_all_time, color: '#8b5cf6' },
    { label: 'Characters in DB', value: stats.total_characters, color: '#06b6d4' },
    { label: 'Total Learners', value: stats.total_learners, color: '#14b8a6' },
  ];

  return (
    <div>
      <h1 className={s.title}>Dashboard</h1>
      <div className={s.statsGrid}>
        {cards.map((card) => (
          <div key={card.label} className={s.statCard}>
            <p className={s.statLabel}>{card.label}</p>
            <p className={s.statValue} style={{ color: card.color }}>{card.value}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
